<template>
    <div>
      <bulletin-upload-form></bulletin-upload-form>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  